// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Roles_roles__CaAxD {
  display: flex;
  flex-wrap: wrap;
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X {
  display: flex;
  flex-wrap: wrap;
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB {
  border-radius: 5px;
  padding: 10px;
  margin-right: 15px;
  margin-bottom: 10px;
  min-width: 170px;
  max-width: 300px;
  height: fit-content;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB .Roles_information__9BKNT .Roles_type__0MtW5 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB .Roles_information__9BKNT .Roles_role-info-personal__HJn7Q {
  font-size: 12px;
  color: rgba(19, 19, 19, 0.6);
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB .Roles_information__9BKNT .Roles_role-info-personal__HJn7Q .Roles_name__Hcbxi {
  color: black;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 5px !important;
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB .Roles_information__9BKNT .Roles_role-info__iPCIl {
  font-size: 12px;
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB .Roles_information__9BKNT .Roles_role-info__iPCIl .Roles_name__Hcbxi {
  color: black;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 5px !important;
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB .Roles_information__9BKNT .Roles_role-info__iPCIl .Roles_unit-permissions__M1bQg {
  font-weight: 500;
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB .Roles_information__9BKNT .Roles_role-info__iPCIl .Roles_unit-permissions__M1bQg span {
  color: rgba(19, 19, 19, 0.6);
}
.Roles_roles__CaAxD .Roles_account-roles__Xng-X .Roles_role__sgJTB .Roles_delete-role__hGOi3 svg {
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.Roles_roles__CaAxD .Roles_add-more-role__oiXtD {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.Roles_roles__CaAxD .Roles_add-more-role__oiXtD svg {
  width: 35px;
  height: 35px;
}
.Roles_roles__CaAxD .Roles_add-more-role__oiXtD svg path {
  stroke: var(--profile-management-color);
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/AccountCreate/Components/Roles/Roles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;AACF;AAAE;EACE,aAAA;EACA,eAAA;AAEJ;AADI;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AAGN;AADQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAGV;AADQ;EACE,eAAA;EACA,4BAAA;AAGV;AAFU;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAIZ;AADQ;EACE,eAAA;AAGV;AAFU;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAIZ;AAFU;EACE,gBAAA;AAIZ;AAHY;EACE,4BAAA;AAKd;AACQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AACV;AAIE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAFJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAEM;EACE,uCAAA;AAAR","sourcesContent":[".roles {\n  display: flex;\n  flex-wrap: wrap;\n  .account-roles {\n    display: flex;\n    flex-wrap: wrap;\n    .role {\n      border-radius: 5px;\n      padding: 10px;\n      margin-right: 15px;\n      margin-bottom: 10px;\n      min-width: 170px;\n      max-width: 300px;\n      height: fit-content;\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      .information {\n        .type {\n          font-size: 18px;\n          font-weight: 500;\n          margin-bottom: 10px;\n        }\n        .role-info-personal {\n          font-size: 12px;\n          color: rgba($color: #131313, $alpha: 0.6);\n          .name {\n            color: black;\n            font-weight: 500;\n            font-size: 14px;\n            margin-bottom: 5px !important;\n          }\n        }\n        .role-info {\n          font-size: 12px;\n          .name {\n            color: black;\n            font-weight: 500;\n            font-size: 14px;\n            margin-bottom: 5px !important;\n          }\n          .unit-permissions {\n            font-weight: 500;\n            span {\n              color: rgba($color: #131313, $alpha: 0.6);\n            }\n          }\n        }\n      }\n      .delete-role {\n        svg {\n          width: 15px;\n          height: 15px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  .add-more-role {\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    svg {\n      width: 35px;\n      height: 35px;\n      path {\n        stroke: var(--profile-management-color);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roles": `Roles_roles__CaAxD`,
	"account-roles": `Roles_account-roles__Xng-X`,
	"role": `Roles_role__sgJTB`,
	"information": `Roles_information__9BKNT`,
	"type": `Roles_type__0MtW5`,
	"role-info-personal": `Roles_role-info-personal__HJn7Q`,
	"name": `Roles_name__Hcbxi`,
	"role-info": `Roles_role-info__iPCIl`,
	"unit-permissions": `Roles_unit-permissions__M1bQg`,
	"delete-role": `Roles_delete-role__hGOi3`,
	"add-more-role": `Roles_add-more-role__oiXtD`
};
export default ___CSS_LOADER_EXPORT___;
